import { themeUi } from '../../themeUi/themeUi';
import backgroundImage from '../../../../screens/Login/components/LoginBackground/assets/BuildingsLight.svg';

export const login = {
  login: {
    formContainer: {
      backgroundColor: themeUi.semantic.color.text.secondary0,
      boxShadow: 'none',
      border: `1px solid ${themeUi.semantic.color.text.secondary300}`,
      color: themeUi.semantic.color.text.secondary800
    },

    background: {
      backgroundColor: themeUi.semantic.color.background.primary0,
      backgroundImage: `url(${backgroundImage})`
    },

    loader: {
      backgroundColor: `color-mix(in srgb, ${themeUi.semantic.color.text.secondary0} 70%, transparent)`
    }
  },

  components: {
    forgotPasswordForm: {
      forgotPasswordTitle: {
        color: themeUi.semantic.color.text.secondary950
      },
      forgotPasswordDescription: {
        color: themeUi.semantic.color.text.secondary800
      }
    },

    mobileBanner: {
      bannerContainer: {
        backgroundColor: themeUi.semantic.color.background.neutral0
      },
      logo: {
        border: {
          color: themeUi.semantic.color.background.neutral300
        }
      },
      heading: {
        color: themeUi.semantic.color.text.secondary950
      },
      body: {
        color: themeUi.semantic.color.text.secondary600
      }
    },

    orSeperator: {
      orText: {
        color: themeUi.semantic.color.text.secondary950,
        backgroundColor: themeUi.semantic.color.background.secondary300
      }
    },

    resetPassword: {
      resetPasswordFormTitle: {
        color: themeUi.semantic.color.text.secondary950
      }
    },

    signInForm: {
      signInTitle: {
        color: themeUi.semantic.color.text.secondary950
      }
    },

    signInFromUserInvitation: {
      signInTitle: {
        color: themeUi.semantic.color.text.secondary950
      },
      setPasswordFormTitle: {
        color: themeUi.semantic.color.text.secondary950
      }
    },

    signUp: {
      components: {
        signUpForm: {
          inlineTerms: {
            color: themeUi.semantic.color.text.secondary800,
            checkboxColor: themeUi.semantic.color.text.primary400
          },
          bigTitleRules: {
            color: themeUi.semantic.color.text.secondary950
          },
          formTitle: {
            color: themeUi.semantic.color.background.neutral500
          }
        }
      }
    },

    socialLogin: {
      socialLoginButton: {
        socialLoginName: {
          color: themeUi.semantic.color.text.secondary950
        }
      }
    },

    ssoLoginForm: {
      signInTitle: {
        color: themeUi.semantic.color.text.secondary950
      }
    },

    userFormInfo: {
      userFormInfoTitle: {
        color: themeUi.semantic.color.text.secondary950
      },
      userFormInfoSubTitle: {
        color: themeUi.semantic.color.text.secondary950
      },
      userFormInfoText: {
        color: themeUi.semantic.color.text.secondary800
      }
    }
  }
};
